import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import {
  REFUND_ACTION,
  RefundDialogComponent,
  RefundDialogData,
  VIEW_INVOICE_ACTION,
} from '../../../refund/refund-dialog/refund-dialog.component';
import { Transaction, TransactionReferenceType } from '@galaxy/billing';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'smb-invoicing-transaction-row-actions',
  templateUrl: './transaction-row-actions.component.html',
  imports: [TranslateModule, MatButtonModule, MatIconModule, MatMenuModule],
})
export class TransactionRowActionsComponent {
  TransactionReferenceType = TransactionReferenceType;

  @Input() row: Transaction;
  @Input() displayIssueCreditNoteAction: boolean;

  @Output() reload = new EventEmitter<void>();
  @Output() issueCreditNote = new EventEmitter<string>();
  @Output() viewInvoice = new EventEmitter<string>();

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  constructor(public dialog: MatDialog) {}

  openMenu(e: MouseEvent): void {
    e.stopPropagation();
    this.trigger.openMenu();
  }

  openRefundDialog(): void {
    const dialogRef = this.dialog.open(RefundDialogComponent, {
      width: '500px',
      data: <RefundDialogData>{
        payment: this.row,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }
      switch (result.action) {
        case REFUND_ACTION:
          this.reload.next();
          break;
        case VIEW_INVOICE_ACTION:
          this.viewInvoice.emit(result.result?.id);
          break;
      }
    });
  }

  issueCreditNoteAction(): void {
    this.issueCreditNote.emit(this.row.referenceId);
  }
}
